import { all } from "redux-saga/effects";

import getNewsSaga from "./getEvents";
import getProfileCandidateSaga from "./getProfileCandidate";
import handleVoteSaga from "./handleVote";
import getVoteResult from "./getVoteResult";
import getProgramsSaga from "./getPrograms";
import getVotesSaga from "./getVotes";
import getDetailEventSaga from "./getDetailEvent";
import getDetailProgramSaga from "./getDetailProgram";
import getPostRemainingSaga from "./getPostRemaining";

export default function* eventSaga() {
  yield all([
    getNewsSaga(),
    getProfileCandidateSaga(),
    handleVoteSaga(),
    getVoteResult(),
    getProgramsSaga(),
    getVotesSaga(),
    getDetailEventSaga(),
    getDetailProgramSaga(),
    getPostRemainingSaga(),
  ]);
}
